/**
 * @flow
 */

import * as React from 'react'

import OrganizationSection from './OrganizationSection'
import {
  Container,
  Title,
  TitleUnderLine,
  DevelopSectionContainer,
  ResponsiveContainer
} from './styledComponents'

type Props = {
  applicationSectionData: object
}

class ApplicationSection extends React.Component<Props> {
  render() {
    const { applicationSectionData } = this.props
    const {
      title,
      applicationsList: organizationsList
    } = applicationSectionData
    return (
      <Container id="what-we-do-section">
        <ResponsiveContainer>
          <Title as="h2">{title}</Title>
          <TitleUnderLine />
          <DevelopSectionContainer>
            {organizationsList.map(eachOrganization => (
              <OrganizationSection
                imageUrl={eachOrganization.imageUrl}
                title={eachOrganization.title}
                content={eachOrganization.content}
              />
            ))}
          </DevelopSectionContainer>
        </ResponsiveContainer>
      </Container>
    )
  }
}

export default ApplicationSection



// WEBPACK FOOTER //
// ./src/components/TeamNew/ApplicationSection/index.js